// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"3524":"app","8293":"component---src-pages-index-js"}[chunkId] || chunkId) + "." + {"3524":"72fb86d0d71c3f715d64","4120":"10ce2bdb4c854c95a31d","8293":"2d765f5687d3d6277deb"}[chunkId] + ".css";
};